<template>
  <div class="row justify-between items-center">
    <div class="col-3 col-xl-2">
      <!-- Search field -->
      <mi-text-field
        :model-value="configurationsSearchString"
        bg-color="white"
        debounce="500"
        placeholder="Search"
        clearable
        hide-bottom-space
        outlined
        @update:model-value="SET_CONFIGURATIONS_SEARCH_STRING"
      >
        <template #prepend>
          <mi-icon name="search"></mi-icon>
        </template>
      </mi-text-field>
    </div>

    <div class="col-auto">
      <mi-btn
        color="primary"
        icon-right="folder-multi"
        icon-right-size="14px"
        @click="$router.push({ name: PAC_SAVED_LISTS_ROUTE.name })"
      >
        Saved Lists
      </mi-btn>
      <!-- New configuration dialog trigger -->
      <mi-btn
        class="q-ml-sm new-configuration-btn"
        color="accent"
        icon-right="plus-circle"
        icon-right-size="14px"
        @click="isNewConfigurationDialogShown = true"
      >
        New Configuration
      </mi-btn>
    </div>

    <!-- New configuration dialog -->
    <mi-dialog
      v-model="isNewConfigurationDialogShown"
      :close-icon="true"
      class="new-configuration-dialog"
      persistent
    >
      <div class="new-configuration-step-description">
        <!-- Title -->
        <h5 class="q-mt-none q-mb-sm"> New configuration </h5>

        <!-- Subtitle -->
        <p class="q-mb-none"> {{ stepsDescriptions[currentStep] }}</p>
      </div>
      <!-- Configuration stepper -->
      <new-configuration-stepper
        v-if="isNewConfigurationDialogShown"
        @update:model-value="val => currentStep = val"
        @create:configuration="handleConfigurationCreatedEvent"
      ></new-configuration-stepper>
    </mi-dialog>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import { PAC_CONFIGURATION_ROUTE, PAC_SAVED_LISTS_ROUTE } from '@/router/routeNames'
  import { SET_CONFIGURATIONS_SEARCH_STRING } from '@/store/modules/pac/mutationTypes'

  import NewConfigurationStepper from '@/components/pac/new-configuration-stepper/NewConfigurationStepper.vue'
  import { NEW_CONFIGURATION_STEPS } from '../../../constants'

  const { mapState, mapMutations } = createNamespacedHelpers('pac')

  export default {
    name: 'ConfigurationsHeader',
    components: {
      NewConfigurationStepper
    },
    data: () => ({
      isNewConfigurationDialogShown: false,
      currentStep: 1,
      stepsDescriptions: NEW_CONFIGURATION_STEPS
    }),
    computed: {
      PAC_SAVED_LISTS_ROUTE() {
        return PAC_SAVED_LISTS_ROUTE
      },
      ...mapState(['configurationsSearchString'])
    },
    methods: {
      ...mapMutations({ SET_CONFIGURATIONS_SEARCH_STRING }),

      handleConfigurationCreatedEvent(id = '') {
        this.isNewConfigurationDialogShown = false

        id && this.$router.push({
          name: PAC_CONFIGURATION_ROUTE.name,
          params: { id }
        })
      }
    }
  }
</script>

<style lang="scss">
  .new-configuration-dialog {
    .q-dialog__inner > .mi-card {
      width: 540px;
      max-width: 540px;
      min-width: 540px;
    }

    .new-configuration-step-description {
      background-color: $mi-anthracite-50;
      margin-left: -24px;
      margin-right: -24px;
      padding-right: 24px;
      padding-left: 24px;
    }

    h5 {
      font-size: 20px;
    }

    .mi-card__section--close-dialog {
      background-color: $mi-anthracite-50;
    }

    ::v-deep(.mi-icon-close) {
      // stylelint-disable declaration-no-important
      font-size: 21px !important;
      width: 21px;
      height: 21px;
    }
  }

  @media (max-width: $mi-responsive-large-width) {
    .new-configuration-dialog {
      .q-dialog__inner > .mi-card {
        width: 540px;
        max-width: 540px;
        min-width: 540px;
      }
    }
  }

  @media (max-width: $mi-responsive-medium-width) {
    .new-configuration-dialog {
      .q-dialog__inner > .mi-card {
        width: 540px;
        max-width: 540px;
        min-width: 540px;
      }
    }
  }
</style>
